import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ position?: 'right' | 'left' }>`
  ${({ theme, position }) => css`
    align-items: center;
    text-decoration: none;
    position: relative; /* Garantir que o tooltip seja posicionado relativamente ao Wrapper */

    div {
      display: flex;
      gap: 1rem;
      align-items: center;
    }

    span {
      font-size: 12px;
      letter-spacing: 1px;
    }

    p {
      color: ${theme.colors.neutral.neutral70};
      margin-bottom: 0rem;
    }

    /* Somente aplica o estilo ::after se o elemento tiver role="tooltip" */
    &[role='tooltip']::after {
      content: attr(aria-label);
      background: ${theme.colors.neutral.neutral70};
      box-shadow: 0px 0px 16px rgba(36, 36, 36, 0.12);
      color: ${theme.colors.neutral.neutral0};
      border-radius: ${theme.border.radius};
      transition: all 0.2s ease;
      padding: 1.2rem;
      opacity: 0;
      top: -6.5rem; /* Ajuste se necessário */
      position: absolute;
      pointer-events: none;
      font-size: 1.2rem;
      width: 22.4rem;
      white-space: pre-wrap;

      /* Garantindo que o tooltip tenha um z-index maior para ficar por cima */
      z-index: 9999; /* Um valor alto o suficiente para sobrepor outros elementos */

      ${position === 'right' ? 'left: 5rem;' : 'right: 5rem;'};
    }

    /* Quando o item com role="tooltip" for hoverado */
    &[role='tooltip']:hover::after {
      pointer-events: all;
      opacity: 1;
    }
  `}
`;
